<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <a-form-model-item
          prop="periodItemId"
          label="周期">
          <!--<a-input placeholder="请输入表单ID" v-model="model.formId" />-->
          <a-select v-model='model.periodItemId' placeholder='请选择表单' @change="periodItemIdChange()" showSearch :filterOption="filterOption">
            <a-select-option :value='item.id' :key="item.id" v-for="item in periodItemList">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          prop="formId"
          label="表单">
          <!--<a-input placeholder="请输入表单ID" v-model="model.formId" />-->
          <a-select v-model='model.formId' placeholder='请选择表单' @change="formIdChange()" showSearch :filterOption="filterOption">
            <a-select-option :value='item.id' :key="item.id" v-for="item in formList">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          prop="formItemId"
          label="表单元素">
          <a-select v-model='model.formItemId' placeholder='请选择元素' showSearch :filterOption="filterOption" >
            <a-select-option :value='item.id' :key="item.id" v-for="item in formItemList">{{item.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
            prop="value"
          label="匹配值">
          <a-input placeholder="请输入匹配值" v-model="model.value" />
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import Vue from 'vue'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import baseRules from '@/constants/baseRules'
  import FormViewItemInput from '../../../components/FormViewItemInput'
  export default {
    name: "ProjectStatisticWorkloadConfigModal",
    components: { FormViewItemInput },
    data () {
      return {
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        title:"操作",
        visible: false,
        model: {},
        rules:{
          periodItemId:[baseRules.required],
          formId:[baseRules.required],
          formItemId:[baseRules.required],
          value:[baseRules.required],
        },
        confirmLoading: false,
        periodItemList:[],
        formList:[],
        formItemList:[],
        url: {
          add: "/project/projectStatisticWorkloadConfig/add",
          edit: "/project/projectStatisticWorkloadConfig/edit",
        },
      }
    },
    created () {
      getAction('/project/projectPeriodItem/list',{projectId:this.projectId,periodItemId:this.model.periodItemId}).then(res=>{
        if(res.success){
          this.periodItemList=res.result
        }
      })
    },
    methods: {
      add () {
        this.edit({
          projectId:this.projectId
        });
      },
      edit (record) {
        this.model = Object.assign({}, record);
        if(this.model.periodItemId){
          this.periodItemIdChange(true)
        }
        if(this.model.formId){
          this.formIdChange(true)
        }
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = this.model;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      formIdChange(init){
        this.formItemList = []
        if(this.model.formItemId && !init ){
          this.model.formItemId = undefined
        }
        if(this.model.formId){
          getAction('/project/projectFormItem/listAll',{formId:this.model.formId}).then(res=>{
            if(res.success){
              this.formItemList = res.result
            }
          })
        }
      },
      periodItemIdChange(init){
        this.formList = []
        this.formItemList = []
        if(this.model.formId && !init ){
          this.model.formId = undefined
        }
        if(this.model.formItemId && !init){
          this.model.formItemId = undefined
        }
        if(this.model.periodItemId){
          getAction('/project/projectForm/listAllByPeriodItemId',{projectId:this.projectId,periodItemId:this.model.periodItemId}).then(res=>{
            if(res.success){
              this.formList=res.result
            }
          })
        }
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>

<style lang="less" scoped>

</style>